<template>
  <div class="form-container">
    <form @submit.prevent="submitQuery">
      <div>
         <!-- Button to add a new knowledge type -->
      <v-btn @click.prevent="showAddTypeDialog = true">Add New Knowledge Type <v-icon>mdi-plus</v-icon></v-btn>
      
      <!-- Dialog for adding a new knowledge type -->
      <v-dialog v-model="showAddTypeDialog" persistent>
        <v-card>
          <v-card-title>
            Add New Knowledge Type
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="newKnowledgeType" label="Knowledge Type"></v-text-field>
            <v-color-picker v-model="newKnowledgeColor" dot-size="30" label="Select Color"></v-color-picker>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="addKnowledgeType">Add</v-btn>
            <v-btn @click="showAddTypeDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <!-- <v-select v-model="knowledgeType" :items="knowledgeTypes" label="Select Knowledge Type"></v-select> -->
        <!-- <v-select v-model="knowledgeType" :items="knowledgeTypes" item-text="text" item-value="text" label="Select Knowledge Type" @change="onKnowledgeTypeChange"></v-select> -->
        <!-- <v-select v-model="knowledgeType" :items="knowledgeTypes" item-text="text" item-value="text" label="Select Knowledge Type" @change="onKnowledgeTypeChange"></v-select> -->
        <v-select
  v-model="knowledgeType"
  :items="knowledgeTypes"
  item-text="text"
  item-value="text"
  label="Select Knowledge Type"
  placeholder="Select Knowledge Type"
  @change="onKnowledgeTypeChange"
></v-select>

        <input
          type="text"
          class="inputarea card-animate-2"
          placeholder="Title"
          v-model="queryTitle"
          @keyup.enter="submitQuery"
        />
        <textarea
          class="inputarea card-animate-2"
          placeholder="Content"
          v-model="queryPrompt"
          rows="4"
          cols="50"
        ></textarea>
      </div>
      <br />
      <!-- <v-icon :color="recordingStateColor">mdi-microphone</v-icon> -->
      <div>
        <v-btn class="mx-2" @click="submitQuery" v-if="isEditing">Update</v-btn>
<v-btn class="mx-2" type="submit" v-else>Submit</v-btn>
        <v-btn class="mx-2" @click="resetDialogue">Reset</v-btn>
      </div>
    </form>
    <div v-if="selectedKnowledgeTypeInfo">
      <v-chip :style="{backgroundColor: selectedKnowledgeTypeInfo.color}">
        {{ selectedKnowledgeTypeInfo.text }}
      </v-chip>
    </div>
    <div id="dialogueResults">
      <p v-for="(entry, index) in dialogueHistory" :key="index" v-html="entry"></p>
    </div>
    <br />
    <div v-if="loading" class="loading-container">
      <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading-spinner.gif" alt="Loading" />
      <br />
      <p>{{ loadingText }}</p>
    </div>
<!-- <saved-knowledge-list
  :saved-knowledge="savedKnowledge"
  @edit-knowledge="handleEditKnowledge"
  @delete-knowledge="deleteKnowledge"
></saved-knowledge-list> -->


    <saved-knowledge-list
      :saved-knowledge="savedKnowledge"
      @edit-knowledge="editSavedKnowledge"
      @delete-knowledge="deleteSavedKnowledge"
    ></saved-knowledge-list>
  </div>
</template>

<script>
import SavedKnowledgeList from "./SavedKnowledgeList.vue";

export default {
  components: {
    SavedKnowledgeList,
  },
  data() {
    return {
      knowledgeType: '',
      knowledgeTypes: [
      { text: 'Personal', color: '#509d43' },
      { text: 'Business', color: '#6ac7f3' },
      { text: 'Misc', color: '#d8f36a' },
    ],
      showAddTypeDialog: false,
      newKnowledgeType: '',
      newKnowledgeColor: '#FFFFFF', // Default color
      loading: false,
      loadingText: "",
      queryPrompt: "",
      queryTitle: "", // Added queryTitle
      dialogueHistory: [],
      savedKnowledge: [],
      isEditing: false,
      editingIndex: -1,
      selectedKnowledgeTypeInfo: null, // To store info about the selected knowledge type
    };
  },
  mounted() {
    this.loadSavedKnowledge();
  },
  watch: {
  knowledgeTypes(newVal) {
    console.log('knowledgeTypes updated', newVal);
  }
},
  methods: {
    saveKnowledge() {
    localStorage.setItem('savedKnowledge', JSON.stringify(this.savedKnowledge));
  },
  loadKnowledge() {
    const knowledge = localStorage.getItem('savedKnowledge');
    if (knowledge) {
      this.savedKnowledge = JSON.parse(knowledge);
    }
  },
  updateKnowledgeType(index, newType, newColor) {
    const item = this.savedKnowledge[index];
    if (item) {
      item.type = newType;
      item.color = newColor;
      this.saveKnowledge();
    }
  },
    submitQuery() {
      if (this.isEditing) {
        this.Vue.set(this.savedKnowledge, this.editingIndex, {
          type: this.knowledgeType,
          prompt: this.queryPrompt,
          title: this.queryTitle, // Save the title
        });
        this.isEditing = false;
      } else {
        this.savedKnowledge.push({
          type: this.knowledgeType,
          prompt: this.queryPrompt,
          title: this.queryTitle, // Save the title
        });
      }
      localStorage.setItem("savedKnowledge", JSON.stringify(this.savedKnowledge));
      this.triggerSubmissionAnimation();
      this.resetDialogue();
      this.saveKnowledge();
      this.updateKnowledgeType(this.editingIndex, this.knowledgeType, this.newKnowledgeColor);
    },
    addKnowledgeType() {
  const typeExists = this.knowledgeTypes.some(type => type.text === this.newKnowledgeType);
  if (this.newKnowledgeType && !typeExists) {
    this.knowledgeTypes.push({
      text: this.newKnowledgeType,
      color: this.newKnowledgeColor
    });
    this.showAddTypeDialog = false;
    this.newKnowledgeType = '';
    this.newKnowledgeColor = '#FFFFFF'; // Reset to default color
    alert("New type of knowledge subject created");
  } else {
    alert("This knowledge type already exists.");
  }
  this.saveKnowledge();
},
onKnowledgeTypeChange(value) {
  // Find the selected knowledge type object by its text
  const selectedType = this.knowledgeTypes.find(type => type.text === value);
  if (selectedType) {
    // Update a data property to store the selected knowledge type's information
    this.selectedKnowledgeTypeInfo = selectedType;
  } else {
    // Reset or handle the case where the selected type is not found
    this.selectedKnowledgeTypeInfo = null;
  }
},
handleEditKnowledge(item) {
    // Assuming you have a dialog component with a color picker
    this.editingItem = item; // Set the item being edited
    this.showEditDialog = true; // Show the dialog with the color picker
  },
  updateItemColor(color) {
    // Find the item in `savedKnowledge` and update its color
    const itemIndex = this.savedKnowledge.findIndex(knowledgeItem => knowledgeItem.title === this.editingItem.title);
    if (itemIndex !== -1) {
      this.savedKnowledge[itemIndex].color = color;
      // Save changes, e.g., to local storage or backend
      this.saveKnowledge();
    }
    this.showEditDialog = false; // Close the dialog
  },
    triggerSubmissionAnimation() {
  const formElement = document.querySelector('.form-container'); // Add a 'form-container' class to your form's div
  if (formElement) {
    formElement.classList.add('fade-in-animation');

    // Optional: Remove the class after animation to reset the state
    setTimeout(() => {
      formElement.classList.remove('fade-in-animation');
    }, 1000); // Matches the animation duration
  }
},
    resetDialogue() {
      this.queryPrompt = "";
      this.knowledgeType = '';
      this.queryTitle = ""; // Reset the title
      this.isEditing = false;
      this.editingIndex = -1;
    },
    editSavedKnowledge(item, index) {
    // Set form to editing state with item's details
    this.isEditing = true;
    this.editingIndex = index;
    this.queryTitle = item.title;
    this.queryPrompt = item.prompt;
    this.knowledgeType = item.type;
    // Additional: Initialize color picker if part of the form
    this.newKnowledgeColor = item.color;
  },

  deleteSavedKnowledge(index) {
    this.savedKnowledge.splice(index, 1);
    this.saveKnowledge(); // Persist changes
    this.resetDialogue();
  },

    loadSavedKnowledge() {
      const stored = localStorage.getItem("savedKnowledge");
      if (stored) {
        this.savedKnowledge = JSON.parse(stored);
      }
    },
  },
};
</script>


<style>
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.02);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-in-animation {
  animation: fadeIn 1s ease forwards;
}
.v-btn {
  margin: 5px;
  color: gradient (red, blue);
}
.v-text-field, .v-textarea {
  margin: 10px 0;
}
.inputarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  resize: vertical;
  --glow: drop-shadow(0 0 1px violet);
  filter: var(--glow) brightness(1.5) drop-shadow(0 0 10px violet);
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 1.2rem;
  color: #000;
}

</style>
